module.exports = __webpack_public_path__ + "static/media/tipologia9.b57aced4.png";